// Persists that the authenticated user has finished/dismissed the onboarding
// wizard by POSTing to the device-connection "onboarded" write endpoint
// (ENG-3796). Mirrors activated.ts (same POST {token} shape, same rpc path
// convention). The server (markOnboarded/main.go) idempotently sets
// users.onboarding_completed_at once via a CAS, so repeated calls are safe.
// Per knowledge: onboarding-gate-signals (ai.knowledge/project) — writing this
// flag is what makes the wizard never show again after finish OR skip.
// Per rule: reference-rules-in-comments (ai.knowledge/global).

/**
 * Mark the authenticated user as onboarded (idempotent server-side).
 *
 * @throws If the network request fails or the server returns non-200. Callers
 *   treat this as fire-and-forget: a failure must NOT block the user from
 *   leaving the wizard (see gate.tsx handleComplete/handleSkip), so the caller
 *   is responsible for catching + swallowing. Surfacing the error here (rather
 *   than swallowing internally) keeps this module a faithful mirror of
 *   activated.ts and lets the caller decide the failure policy.
 */
// The service path prefix is REQUIRED. `config.apiEndpoint` is the bare host
// (https://api.itg.tryiris.ai/), and posting to `<host>/rpc/...` returns 403 for
// EVERY route — not just this one — because the gateway only maps rpc paths
// under the owning service. Verified against ITG: bare host 403s on activated,
// history, and config.get alike; the prefixed path resolves.
const AGENT_CONFIG_BASE = 'api/v1/agent-config/';

export const markOnboarded = async (token: string, apiEndpoint: string): Promise<void> => {
  const url = `${apiEndpoint}${AGENT_CONFIG_BASE}rpc/api.authenticated.v2.agent-config.device-connection.onboarded`;

  const response = await fetch(url, {
    body: JSON.stringify({ token }),
    headers: { 'Content-Type': 'application/json' },
    method: 'POST'
  });

  if (!response.ok) {
    throw new Error(`onboarded endpoint returned ${response.status}`);
  }
};
